import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    DropdownMenu,
    DropdownToggle,
    DropdownItem,
} from 'reactstrap';
import { actions } from '../../../../context';

const AssignableUserList = () => {
    const dispatch = useDispatch();

    // null or a guid to filter practice list by the given userId
    const assignedFilterUser = useSelector((state) => state.practice.assignedFilterUser);

    // TODO: make this more effiecient
    const checkUserEquality = (leftState, rightState) => {
        if (leftState.length === rightState.length) {
            const checkUserIsInOldState = (user) => rightState.some((u) => u.id === user.id);
            if (leftState.every(checkUserIsInOldState)) return true;
        }
    };
    const admins = useSelector((state) => state.users.users, checkUserEquality);

    useEffect(() => {
        dispatch(actions.users.fetchAssignableUsers());
    }, [dispatch]);
    
    const updateAssignedFilterUser = (userId) => {
        dispatch(actions.practice.getAssignedUser(userId));
    };

    let selectedUser = 'Anyone';
    const assignedFilterOptions = [
            {
                value: null,
                label: `Anyone`,
            },
            ...admins?.map((a) => {
                const label = `${a.firstName} ${a.lastName}`;
                const choice = {
                    value: a.id,
                    label
                };
                if (a.id === assignedFilterUser) {
                    selectedUser = label;
                }
                return choice;
            }),
        ];

    return (
        <>
            <DropdownToggle className="px-3 sc-glass" color="primary" caret>
                {selectedUser}
            </DropdownToggle>
            <DropdownMenu style={{ maxHeight: '250px', overflowX: 'auto' }}>
                {assignedFilterOptions.map((o) => (
                    <DropdownItem
                        key={o.value}
                        onClick={() => updateAssignedFilterUser(o.value)}>
                        {o.label}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </>
    );
};

export default React.memo(AssignableUserList);
